import { FC } from "react";
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router';
import { useConfiguration } from "../hooks/useConfiguration";
import { getUrlByContext } from "../utils";

interface LinkProps extends RouterLinkProps {}

export const Link: FC<LinkProps> = ({
    className,
    to,
    children,
    ...props
}) => {
    const config = useConfiguration();
    const targetTo = getUrlByContext(to.toString(), config.teamName);

    if (config.standalone) {
        return (
            <RouterLink to={targetTo} className={className} {...props}>
                {children}
            </RouterLink>
        );
    }

    return <a href={targetTo} className={className}>{children}</a>;
}